import { RiskSegment } from '../../components/Tooltips/RiskSegment/RiskSegmentIndicator';

export enum PlayerCardTabs {
  Overview = 'Overview',
  Transactions = 'Transactions',
  Comments = 'Comments',
  Bets = 'Bets',
  History = 'History',
  Bonuses = 'Bonuses',
  Limits = 'Limits',
  LinkedPlayers = 'Linked Players',
}

export interface PlayerSummaryResponse {
  Comment?: string;
  CommentTypeId?: number;
  PlayerId: number;
  PlayerUuid: string;
  ExternalPlayerId: string;
  CountryName: string;
  CompanyName: string;
  LastLoginDate: Date;
  CompanyId: number;
  CommentChangeDateUtc?: string;
  ManagerCommentedName?: string;
  RiskSegments: RiskSegment[];
  FranchiseId: number;
  FranchiseName: string;
}

export interface PlayerPerformanceResponse {
  AverageBetStake: number;
  BetCount: number;
  MaxAmountInPlay: number;
  MaxAmountPrematch: number;
  MaxMultiplierInPlay: number;
  MaxMultiplierPrematch: number;
  PercentSingles: number;
  Profit: number;
  ProfitMargin: number;
  Turnover: number;
}

export interface PlayerAccountBalanceResponse {
  Currency: string;
  SportsBonusBalance: number;
  SportsBonusRollover: number;
  Balance?: number;
}

export interface CheckBalanceResponse {
  Currency: string;
  Balance: number;
  ManagerCurrency: string;
  BalanceInManagerCurrency: number;
}

export interface PlayerPreviewLinkResponse {
  Url: string;
  Token: string;
  ExpiresAt: string;
}

export interface PlayerAccountSettingsResponse {
  PlayerId: number,
  PlayerUuid: string,
  ExternalPlayerId: string,
  PlayerLogin: string,
  Currency: string,
  CurrencyId: number,
  DateCreated: Date
}

export interface PlayerHistoryResponse {
  Changes: string,
  ChangeTime: Date,
  ManagerName: string
}

export interface PlayerLoginSessionsResponse {
  LoginTime: Date,
  LoginSource: string,
  IpAddress: string
}
